import { api } from '@converse/headless';
import { html } from 'lit';
import { CustomElement } from './element.js';

export class ConverseFooter extends CustomElement {
    render() {
        return html``;
    }
}

api.elements.define('converse-footer', ConverseFooter);
